<script setup lang="ts"></script>

<template>
  <div class="loading-wrapper">
    <img class="loading-logo" alt="Loading ..." src="@/assets/images/main-shape.svg" />
    <div class="loading-bar">
      <v-progress-linear color="#3B755F" indeterminate rounded height="6" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.loading-wrapper {
  width: 110%;
  height: 100%;
  background: var(--ui-white);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-left: -40px;
}

.loading-logo {
  width: 150px;
  margin-bottom: 30px;
}

.loading-bar {
  width: 200px;
}

@include media('xs-only') {
  .loading-wrapper {
    margin-left: 0;
    width: 100%;
    padding: 10px 10px 150px;
  }

  .loading-bar {
    width: 150px;
  }

  .loading-logo {
    width: 100px;
    margin-bottom: 30px;
  }
}
</style>
